


export enum WorkloadSummaryMode {

    HOURS           = 'summary_hours',
    TASKS           = 'summary_tasks',
    STORY_POINTS    = 'summary_story_points'


}